<template>
  <div class="effective">
    <div class="content">
      <p class="font-34 c-191F25">希望规则什么时候生效</p>
      <div class="font-26 c-191F25-56">
        <p>选择立即生效，则今日考勤结果将按新</p>
        <p>规则重新算</p>
      </div>
      <ul class="font-34 c-006AFE">
        <li @click="methodIsEffective(1)" style="font-weight: bold">
          立即生效
        </li>
        <li @click="methodIsEffective(2)">明天生效</li>
        <li @click="methodIsEffective(0)">取消</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    img: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    methodIsEffective(value) {
      this.$emit('isEffective', value)
    }
  }
}
</script>
<style lang="scss" scoped>
.effective {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.56);
  .content {
    width: 280px;
    height: 250px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    background: #ffffff;
    > p {
      margin-top: 19px;
      height: 38px;
      line-height: 38px;
    }
    > div {
      margin-bottom: 22px;
      height: 40px;
      p {
        height: 20px;
        line-height: 20px;
      }
    }
    ul > li {
      border-top: 1px solid rgba(25, 31, 37, 0.08);
      height: 44px;
      line-height: 44px;
    }
  }
}
</style>
